<script>
import { mapActions } from "vuex";
import Bahn1EventInfo from "@/components/ui/Bahn1/Bahn1EventInfo.vue";
import Bahn1Agenda from "@/components/ui/Bahn1/Bahn1Agenda.vue";
import Bahn1Speakers from "@/components/ui/Bahn1/Bahn1Speakers.vue";
import Bahn1VideoTeaser from "@/components/ui/Bahn1/Bahn1VideoTeaser.vue";
import Bahn1Contact from "@/components/ui/Bahn1/Bahn1Contact.vue";
import Bahn1Updates from "@/components/ui/Bahn1/Bahn1Updates.vue";
import Bahn1RecapVideo from "@/components/ui/Bahn1/Bahn1RecapVideo.vue";
import Bahn1Gallery from "@/components/ui/Bahn1/Bahn1Gallery.vue";
import Bahn1WichtigsteImpulse from "@/components/ui/Bahn1/Bahn1WichtigsteImpulse.vue";
import Bahn1Statements from "@/components/ui/Bahn1/Bahn1Statements.vue";
import Bahn1ImpulseNew from "@/components/ui/Bahn1/Bahn1ImpulseNew.vue";
import Bahn1Anmeldung from "../components/ui/Bahn1/Bahn1Anmeldung.vue";

export default {
  name: "Bahn1View",
  components: {
    Bahn1EventInfo,
    Bahn1Agenda,
    Bahn1Speakers,
    Bahn1VideoTeaser,
    Bahn1Contact,
    Bahn1Updates,
    Bahn1RecapVideo,
    Bahn1Gallery,
    Bahn1WichtigsteImpulse,
    Bahn1Statements,
    Bahn1ImpulseNew,
    Bahn1Anmeldung
  },
  data() {
    return {
      ideaIcon1: require("@/assets/lightbulb-l.png"),
      ideaIcon2: require("@/assets/speech-bubble-l.png"),
      ideaIcon3: require("@/assets/compass-l.png"),
      ideaIcon4: require("@/assets/banner-l.png")
    };
  },
  methods: { ...mapActions("bahn1", ["loadBahn1"]) },
  mounted() {
    this.loadBahn1();
  }
};
</script>

<template>
  <div class="bahn1-view">
    <Bahn1EventInfo />
    <Bahn1Updates />
    <Bahn1RecapVideo />
    <Bahn1Gallery />
    <Bahn1WichtigsteImpulse />
    <Bahn1Statements />
    <Bahn1ImpulseNew />

    <section class="bahn1-section">
      <h2>Die Idee hinter BAHN 1</h2>
      <p>
        Als Betreiber von 12 Bädern wissen wir: Kommunale Bäder stehen vor
        vielfältigen und akuten Herausforderungen. Doch auch wenn uns die
        Gegenwart herausfordert, wartet die Zukunft nicht. BAHN 1 schafft
        deshalb bewusst Raum für den Blick nach vorn.
        <b>Die Zukunft beginnt auf BAHN 1.</b>
      </p>
      <v-row>
        <v-col cols="12" sm="6" md="3" class="idea-col">
          <v-card class="ideas-icon">
            <img :src="ideaIcon1" width="40px" height="40px" class="ideaIcon" />
          </v-card>
          <p class="ideas-header"><b>Impulse setzen</b></p>
          <p>Neue Ideen und Denkanstöße für kommunale Bäder.</p>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="idea-col">
          <v-card class="ideas-icon">
            <img :src="ideaIcon2" width="40px" height="40px" class="ideaIcon" />
          </v-card>
          <p class="ideas-header"><b>Perspektiven teilen</b></p>
          <p>Im Austausch voneinander lernen.</p>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="idea-col">
          <v-card class="ideas-icon">
            <img :src="ideaIcon3" width="40px" height="40px" class="ideaIcon" />
          </v-card>
          <p class="ideas-header"><b>Orientierung geben</b></p>
          <p>Zusammenhänge verstehen und Entwicklungen einordnen.</p>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="idea-col">
          <v-card class="ideas-icon">
            <img :src="ideaIcon4" width="40px" height="40px" class="ideaIcon" />
          </v-card>
          <p class="ideas-header"><b>Zukunft gestalten</b></p>
          <p>Heute die Weichen für morgen stellen.</p>
        </v-col>
      </v-row>
    </section>

    <section class="bahn1-section">
      <h2>Startschuss 2026</h2>
      <p>
        Am 12. November 2026 fällt der Startschuss für BAHN 1. Die
        Auftaktveranstaltung beginnt mit einem Perspektivwechsel:
        <b
          >Nicht nur fragen, was Bäder kosten - sondern was wir ohne sie
          verlieren.</b
        >
      </p>
      <p>
        Dieter Könnes führt als Moderator durch einen Tag voller spannender
        Impulsvorträge, paralleler Sessions zum Vertiefen und Mitdiskutieren
        sowie Raum für Austausch und Vernetzung.
      </p>
    </section>

    <Bahn1Agenda id="bahn1-agenda" />

    <section class="bahn1-section">
      <h2>Mitwirkende</h2>
      <p>
        Zusammen mit Expert:innen aus Wissenschaft, Praxis und Verbänden nehmen
        wir die Themen in den Blick, die Kommunen morgen bewegen.
      </p>
      <Bahn1Speakers />
    </section>

    <Bahn1VideoTeaser />
    <Bahn1Anmeldung id="bahn1-anmeldung" />

    <section class="bahn1-section">
      <h2>Ihre Ansprechperson</h2>
      <Bahn1Contact />
    </section>
  </div>
</template>

<style scoped>
.bahn1-view {
  padding: 0 16px;
  overflow-x: hidden;
}
.bahn1-view > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.bahn1-view > * + * {
  margin-top: 56px !important;
}
.bahn1-section > h2 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 30px;
  letter-spacing: 0.6px;
}
.bahn1-section p {
  margin-bottom: 24px;
  font-family: "GeometriaLight";
  letter-spacing: 0.32px;
}
.bahn1-section > *:last-child {
  margin-bottom: 0;
}
.idea-col {
  text-align: center;
  padding-bottom: 0;
}
.idea-col p:last-child {
  margin-bottom: 0;
}
.ideas-icon {
  margin: 0 auto 24px;
  border-radius: 50% !important;
  box-shadow: none !important;
  width: 72px;
  height: 72px;
  text-align: center;
  padding: 16px;
}
.ideas-header {
  margin-bottom: 16px !important;
}
</style>
